<template>
  <div>
    <create-article
      v-if="newArticle"
      :article="newArticle"
      :redirect-cancel-to="{ name: 'associated-press' }"
      :redirect-save-to="{ name: 'associated-press' }">
    </create-article>

    <v-snackbar v-model="snackbar.show" right bottom :color="snackbar.color">
      {{ snackbar.message }}
      <template v-slot:action>
        <v-btn text @click="snackbar.show = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import CreateArticle from '@/views/Home/Articles/CreateArticle'
import get from 'lodash/get'
import isNull from 'lodash/isNull'
import isEmpty from 'lodash/isEmpty'

export default {
  components: {
    CreateArticle
  },
  data () {
    return {
      snackbar: {
        show: false,
        message: null,
        color: 'success'
      },
      loading: true,
      newArticle: null
    }
  },
  computed: {
    ...mapState({
      associatedPress: state => state.associatedPress.articleDetails
    })
  },
  async created () {
    if (!isNull(this.associatedPress) && !isEmpty(this.associatedPress)) {
      this.mapToArticle()
    } else {
      try {
        this.loading = true
        await this.getAPArticleDetails({ itemId: this.$route.params.id })
        this.mapToArticle()
      } catch (err) {
        this.showSnackbar(err, 'error')
      } finally {
        this.loading = false
      }
    }
  },
  methods: {
    showSnackbar (message, color = 'success') {
      this.snackbar.message = message
      this.snackbar.show = true
      this.snackbar.color = color
    },
    mapToArticle () {
      this.newArticle = {
        title: get(this.associatedPress, 'headline'),
        content_description: get(this.associatedPress, 'content_description'),
        short_title: get(this.associatedPress, 'title'),
        ap_product_id: get(this.associatedPress, 'meta.products[0].id'),
        ap_item_id: get(this.associatedPress, 'altids.itemid'),
        uri: get(this.associatedPress, 'uri'),
        pub_status: get(this.associatedPress, 'pubstatus'),
        version_created: get(this.associatedPress, 'versioncreated'),
        author: get(this.associatedPress, 'bylines[0].by', 'AP Media'),
        summarized_description: get(this.associatedPress, 'headline_extended')
      }
    },
    ...mapActions({
      getAPArticleDetails: 'associatedPress/getAPArticleDetails'
    })
  }
}
</script>
